import React from 'react';
import PropTypes from 'prop-types';
import Avatar from '@strava/ui/Avatar';
import AvatarGroup from '@strava/ui/AvatarGroup';
import { isEmpty } from 'lodash-es';
import { t } from '../../shared/onboardingUtils';

import styles from './OnboardingFacepile.scss';

const OnboardingFacepile = ({ athletes, showText }) => (
  <div className={styles.onboardingFacepile} data-testid="onboarding-facepile">
    {!isEmpty(athletes) && (
      <>
        <AvatarGroup>
          {athletes.slice(0, 3).map((athlete) => (
            <Avatar
              key={athlete.id}
              title={athlete.displayName}
              src={athlete.picture || ''}
              type="athlete"
              alt=""
            />
          ))}
        </AvatarGroup>
        {showText && <small>{t('facepile.your_community')}</small>}
      </>
    )}
  </div>
);

OnboardingFacepile.defaultProps = {
  showText: false
};

OnboardingFacepile.propTypes = {
  athletes: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  showText: PropTypes.bool
};

export default OnboardingFacepile;
